export function AddIcon() {
  return (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title>Add</title>
      <g clipPath="url(#clip0_3844_8385)">
        <path d="M9.88 9.38V0H11.12V9.38H20.5V10.62H11.12V20H9.88V10.62H0.5V9.38H9.88Z" fill="currentColor" />
      </g>
      <defs>
        <clipPath id="clip0_3844_8385">
          <rect width="20" height="20" fill="white" transform="translate(0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
}
